import React from 'react';
import { PortableText } from '@portabletext/react';
import getYouTubeId from 'get-youtube-id';
import urlBuilder from '@sanity/image-url';
import sanityClient from '../../sanityClient';

const builder = urlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}

const SanityImage = ({ value }) => {
  if (!value?.asset?._ref) {
    return null;
  }
  return (
    <img
      className="post-body-image"
      alt={value.alt || ' '}
      loading="lazy"
      src={urlFor(value).width(800).fit('max').auto('format')}
    />
  );
};

const nestedPortableTextComponents = {
  types: {
    image: SanityImage,
  },
};

const YouTubeEmbed = ({ value }) => {
  const id = getYouTubeId(value.url);
  const url = `https://www.youtube.com/embed/${id}`;
  
  if (!id) {
    return <div>Missing YouTube URL</div>;
  }

  return (
    <iframe
      className="guide__video"
      width="560"
      height="315"
      src={url}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
  );
};

const Note = ({ value }) => {
  return (
    <div className="guide__note">
      <div className="tooltip__icon guide__note__tooltip-icon">?</div>
      <div className="guide__note__description">
        <PortableText value={value.content} components={nestedPortableTextComponents} />
      </div>
    </div>
  );
};

export const portableTextComponents = {
  types: {
    image: SanityImage,
    youtube: YouTubeEmbed,
    note: Note,
  },
};
